import React from 'react'

// components
import {
  CRow
} from '@coreui/react-pro'
import FormTextInput from '../general-input-form/FormTextInput'
import FormSwitchInput from '../general-input-form/FormSwitchInput'

const AppForm = ({
  values,
  handleChange,
  errors,
  handleSwitch
}) => {
  return (
    <>
      <CRow className="mb-4">
        <FormTextInput 
          id='clientvoucher_client_code'
          name='clientvoucher_client_code'
          colSize='6'
          inputLabel='Client Code'
          className='mb-3'
          placeholder='Enter client code...'
          value={values.clientvoucher_client_code}
          handleTextInput={handleChange}
          feedbackInvalid={errors?.clientvoucher_client_code}
          invalid={errors?.clientvoucher_client_code}
        />
        <FormSwitchInput 
          id='clientvoucher_is_used'
          name='clientvoucher_is_used'
          colSize='3'
          inputLabel='Used?'
          className='mb-3'
          handleSwitch={(e) => handleSwitch(e, 'clientvoucher_is_used')}
          value={values.clientvoucher_is_used}
          invalid={errors?.clientvoucher_is_used}
        />
        <FormSwitchInput 
          id='clientvoucher_is_game_pass'
          name='clientvoucher_is_game_pass'
          colSize='3'
          inputLabel='Game Pass?'
          className='mb-3'
          handleSwitch={(e) => handleSwitch(e, 'clientvoucher_is_game_pass')}
          value={values.clientvoucher_is_game_pass}
          invalid={errors?.clientvoucher_is_game_pass}
        />
      </CRow>
    </>
  )
}

export default AppForm